import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { IntegradorService } from '../../../../services/integrador.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../services/toast.service';
import { Pesagem91p } from '../../../../types/Pesagem91p.type';

@Component({
  selector: 'app-pesagem91p',
  templateUrl: './pesagem91p.component.html',
  styleUrl: './pesagem91p.component.css',
  providers: [ConfirmationService]
})
export class Pesagem91pComponent implements OnInit {
  loading: boolean = false;
  pesagens91p: Pesagem91p[] = []

  constructor(private integradorService: IntegradorService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarPesagems();
  }

  carregarPesagems(){
    this.loading = true;
    this.pesagens91p = [];
    this.integradorService.getPesagens91p().subscribe({
      next: (data) => {
        this.pesagens91p = data
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreNovoDialog() {
    this.router.navigate(["novo"])
  }

  excluir(id: string){
    this.integradorService.deletePesagem91p(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Pesagem excluída com sucesso");
        this.carregarPesagems();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }
}
